const urlIsSafeToNavigate = (targetUrl) => {
  const url = decodeURIComponent(targetUrl);

  const javaScriptProtocolRegx =
    // eslint-disable-next-line no-control-regex
    /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;

  if (javaScriptProtocolRegx.test(url) || javaScriptProtocolRegx.test(targetUrl)) {
    return false;
  }

  // possible redirect to other domains like //domain.com
  if (url.substr(0, 2) === '//') {
    return false;
  }

  // urls should be like '/path' or otherwise they should be in the same domain
  if (/^\/?http/.test(url.toLowerCase())) {
    const targetHost = url.substr(9)?.split('/')?.[0];
    if (targetHost !== document.location.host) {
      return false;
    }
  }
  return url.toLowerCase().search(/javascript:|data:/) === -1;
};

export default urlIsSafeToNavigate;
